<template>
  <div class="convite-falecimento">
    <!-- Cabeçalho decorativo -->
    <div class="cabecalho">
      <div class="decoracao">
        <img :src="require('@/assets/images/ramalhete.png')" alt="" />
      </div>
      <div class="cruz"> <img :src="require('@/assets/images/logos/grupoparque2.png')" alt="" class="logo"/></div>
      <div class="decoracao">
        <img :src="require('@/assets/images/ramalhete-direita.png')" alt="" />
      </div>
    </div>

    <!-- Mensagem -->
    <p class="mensagem">Nós, familiares, comunicamos o falecimento de</p>

    <!-- Foto -->
    <div class="container-foto">
      <div class="quadro-foto">
        <img
          :src="
            getFotoPerfilUrl(props.dados?.nome_arquivo_foto_perfil) ||
            fotoPadrao
          "
          :alt="`Foto de ${props.dados?.pessoa_falecida?.nome}`"
          class="foto"
        />
      </div>
    </div>

    <!-- Nome e datas -->
    <div class="container-nome">
      <h1 class="nome">{{ props.dados?.pessoa_falecida?.nome_social || props.dados?.pessoa_falecida?.nome }}</h1>
      <p v-if="mostrarNomeOriginal" class="nome-original">{{ props.dados?.pessoa_falecida?.nome }}</p>
    </div>
    <p class="datas">{{ nascimentoFormatada }} - {{ falecimentoFormatado }}</p>

    <!-- Eventos -->
    <div class="container-eventos">
      <div class="cartao-evento">
        <h3 class="titulo-evento">Velório</h3>
        <div class="detalhes-evento">
          <p class="local">{{ props.dados?.local_velorio }}</p>
          <p class="datahora">{{ dataVelorioFormatada }}</p>
        </div>
      </div>

      <div class="cartao-evento">
        <h3 class="titulo-evento">Sepultamento</h3>
        <div class="detalhes-evento">
          <p class="local">{{ props.dados?.local_sepultamento }}</p>
          <p class="datahora">{{ dataSepultamentoFormatada }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import { getFotoPerfilUrl } from "@/services/config";

const props = defineProps({
  dados: {
    type: Object,
    required: true,
  },
});
const fotoPadrao = computed(() => {
  return props.dados?.pessoa_falecida?.sexo?.toLowerCase() === "Feminino"
    ? require("@/assets/feminino.png")
    : require("@/assets/masculino.png");
});

function formatarData(dataHoraStr, formato = "extenso") {
  if (!dataHoraStr) return "";

  const meses = [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro",
  ];

  // Separa data e hora
  const [dataStr, horaStr] = dataHoraStr.split(" ");

  if (!dataStr) return "";

  const [ano, mes, dia] = dataStr.split("-");
  if (!ano || !mes || !dia) return dataHoraStr;

  if (formato === "extenso") {
    // Pega só hora e minuto, ex: "11:00"
    const horaFormatada = horaStr ? horaStr.slice(0, 5) : "";

    // Monta string: "18 de junho de 2025 - 11:00h"
    return (
      `${parseInt(dia)} de ${meses[parseInt(mes) - 1]} de ${ano}` +
      (horaFormatada ? ` - ${horaFormatada}h` : "")
    );
  } else if (formato === "curto") {
    return (
      `${dia.padStart(2, "0")}/${mes.padStart(2, "0")}/${ano}` +
      (horaStr ? ` ${horaStr}` : "")
    );
  }

  return dataHoraStr;
}

const nascimentoFormatada = computed(() =>
  formatarData(props.dados?.pessoa_falecida?.data_nascimento, "curto")
);

const falecimentoFormatado = computed(() =>
  formatarData(props.dados?.pessoa_falecida?.data_falecimento, "curto")
);

const dataVelorioFormatada = computed(() =>
  formatarData(props.dados?.data_velorio, "extenso")
);

const dataSepultamentoFormatada = computed(() =>
  formatarData(props.dados?.data_sepultamento, "extenso")
);

// Computed property para verificar se deve mostrar o nome original
const mostrarNomeOriginal = computed(() => {
  const nomeSocial = props.dados?.pessoa_falecida?.nome_social;
  const nome = props.dados?.pessoa_falecida?.nome;
  return nomeSocial && nome && nomeSocial !== nome;
});
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Crimson+Text&family=Lora&family=Merriweather&family=Playfair+Display&display=swap");

.convite-falecimento {
  width: 500px;
  margin: 0;
  padding: 20px;
  background: #f4f1ea;
  color: #2c2c2c;
  text-align: center;
  font-family: "Merriweather", serif;
  position: relative;
}

.cabecalho {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.cruz {
  width: 180px;
  height: 180px;
}


.cruz img {
  width: 100%;
  height: 100%;
}

.decoracao {
  opacity: 0.6;
  width: 80px;
  height: 80px;
}

.decoracao img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: saturate(0) contrast(150%) brightness(70%);
}

.mensagem {
  margin: 0 0 15px;
  font-size: 15px;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 400;
  color: #6b6b6b;
  line-height: 1.4;
}

.container-foto {
  margin: 15px 0;
}

.quadro-foto {
  width: 180px;
  height: 180px;
  margin: 0 auto;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid white;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.foto {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.container-nome {
  margin: 10px 0 2px;
}

.nome {
  font-size: 28px;
  font-weight: 400;
  margin: 0;
  line-height: 1.3;
  color: #2c2c2c;
}

.nome-original {
  font-size: 14px;
  font-weight: 200;
  margin: 2px 0 0;
  color: #6b6b6b;
  font-style: italic;
}

.datas {
  font-size: 16px;
  margin-bottom: 40px;
  color: #6b6b6b;
  letter-spacing: 0.5px;
}

.container-eventos {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 15px 0;
}

.cartao-evento {
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  padding: 10px 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  margin: 0 40px;
}

.titulo-evento {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #2c2c2c;
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
}

.titulo-evento::after {
  content: "";
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 2px;
  background: #d4af37;
  border-radius: 1px;
}

.detalhes-evento p {
  margin: 5px 0;
  font-size: 15px;
  line-height: 1.4;
}

.local {
  font-weight: 500;
  color: #2c2c2c;
}

.datahora {
  color: #6b6b6b;
}

.container-logo {
  width: 120px;
  height: 120px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  margin-top: 3rem;
}
</style>
